const soundUrl = new URL("../assets/audio/error.wav", import.meta.url).href
let errorAudio

export const prepareBarcodeErrorSound = () => {
  if (!errorAudio && typeof Audio !== "undefined") {
    errorAudio = new Audio(soundUrl)
    errorAudio.preload = "auto"
  }
  return errorAudio
}

export const playBarcodeErrorSound = () => {
  try {
    const audio = prepareBarcodeErrorSound()
    if (!audio) return
    audio.pause()
    audio.currentTime = 0
    audio.play()?.catch(() => {})
  } catch {
    // Keep the visible scan error available if the browser cannot play audio.
  }
}
